var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHelpInfo24 = function SvgHelpInfo24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 9.606a4 4 0 0 1 6.219-3.329l.175.117A3.605 3.605 0 0 1 13 12.95V14a1 1 0 1 1-2 0v-1.727c0-.703.57-1.273 1.273-1.273h.121a1.606 1.606 0 0 0 .891-2.941l-.176-.118A2 2 0 0 0 10 9.606V10a1 1 0 1 1-2 0v-.394ZM13 17a1 1 0 1 1-2 0 1 1 0 0 1 2 0Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2ZM4 12a8 8 0 1 1 16 0 8 8 0 0 1-16 0Z",
    fill: "currentColor"
  })));
};
export default SvgHelpInfo24;